module.exports = __webpack_public_path__ + "img/KSC04287.33f19adc.jpg";